export const PROCEDURES = {
  key: 'PROCEDURES',
  value: 4,
  group: 1,
  title: 'health-record.surgeries.procedure_title',
  sub_title: 'Procedure',
  menu_title: 'health-record.surgeries.procedure_title',
  imageURL: require('@assets/images/Health-Record-Icons/Icon-Procedures.svg'),
  icon: 'hotel',
  editor: 'ProcedureEditor',
  message_translate: 'health-record.surgeries.message',
  model_name: 'procedure',
  resource: 'hr/procedure/',
  plain_resource: 'procedure',
  id: 'hr_id',
  headers: [
    {
      text: 'health-record.surgeries.procedure',
      value: 'record.procedure',
    },
    {
      text: 'health-record.surgeries.procedure-date',
      value: 'record.date_formatted',
    },
    {
      text: 'health-record.surgeries.histology_report',
      value: 'record.histology_report',
    },
    {
      text: 'health-record.surgeries.complication',
      value: 'record.complication',
    },
    {
      text: 'health-record.surgeries.facility',
      value: 'record.hospital',
    },
    {
      text: 'health-record.actions',
      value: 'actions',
      sortable: false,
      width: '100px',
    },
  ],
  sortables: {
    record: {
      date_formatted: 'date',
      procedure: 'procedure',
      histology_report: 'histology_report',
      implant: 'implant',
      complication: 'complication',
      hospital: 'hospital',
    },
  },
  show_menu: true,
  background: 'linear-gradient(122.25deg, #B6286D 3.07%, #DA328E 100%)',
  color: '#DA328E',
  opaque: '#F4D2E4',
}
